import { IPoint2d } from '@/editor/math/IPoint2d';
import { IUpdataDataOptions } from './measureAbsorbManager';
import { pixelRatio2d, thresholdValue } from '@/editor/math/const';
import { SCENE_SIZE } from '@/editor/constant/scene';

export function getAreaDimensionStatus(options?: IUpdataDataOptions) {
  const enabled =
    typeof options?.areaDimension === 'boolean' ? !!options.areaDimension : !!options?.areaDimension?.enabled;
  const excludeIds = enabled
    ? typeof options?.areaDimension === 'object'
      ? (options.areaDimension.excludeIds ?? [])
      : []
    : [];

  return {
    enabled,
    excludeIds
  };
}

export function clipToScene(point: IPoint2d, dir: IPoint2d) {
  const size = SCENE_SIZE * pixelRatio2d;
  const [minX, minY] = [-size, -size];
  const [maxX, maxY] = [size, size];

  const { x, y } = point;
  const { x: dx, y: dy } = dir;
  const ts = [];

  if (Math.abs(dx) > thresholdValue) {
    ts.push((minX - x) / dx);
    ts.push((maxX - x) / dx);
  }
  if (Math.abs(dy) > thresholdValue) {
    ts.push((minY - y) / dy);
    ts.push((maxY - y) / dy);
  }

  const points = [];
  for (const t of ts) {
    const px = x + t * dx;
    const py = y + t * dy;
    if (
      px >= minX - thresholdValue &&
      px <= maxX + thresholdValue &&
      py >= minY - thresholdValue &&
      py <= maxY + thresholdValue
    ) {
      points.push({ x: px, y: py, t });
    }
  }

  points.sort((a, b) => a.t - b.t);
  return points.slice(0, 2);
}
